// extracted by mini-css-extract-plugin
export default {"SButton":"SButtonDark_SButton__5QI9q"};